import Phaser from 'phaser';
import { loadManifest, queueBootAssets, registerAnimations, type Manifest } from '../assets';
import { hubState } from '../ui/hub';

/** Affiche une erreur de chargement visible dans la couche UI (jamais d'écran vide). */
export function showBootError(message: string): void {
  hubState.visible.value = false;
  const root = document.getElementById('ui');
  if (!root) return;
  const panel = document.createElement('div');
  panel.className = 'panel boot-error';
  const title = document.createElement('p');
  title.textContent = 'Impossible de charger les ressources du jeu. Rechargez la page.';
  const detail = document.createElement('p');
  detail.className = 'boot-error-detail';
  detail.textContent = message;
  panel.append(title, detail);
  root.append(panel);
}

export class BootScene extends Phaser.Scene {
  constructor() { super('Boot'); }
  async create(): Promise<void> {
    try {
      const manifest: Manifest = await loadManifest();
      this.registry.set('manifest', manifest);
      queueBootAssets(this.load, manifest); // icônes et interface ; cartes et atlas chargés salle par salle (RoomScene)
      const failed: string[] = [];
      this.load.on('loaderror', (file: Phaser.Loader.File) => { failed.push(file.key); });
      this.load.once('complete', () => {
        try {
          if (failed.length) throw new Error(`Fichiers introuvables : ${failed.join(', ')}`);
          registerAnimations(this.anims, manifest, this.textures);
          this.scene.start('Hub');
          hubState.booted.value = true;
          hubState.visible.value = true;
        } catch (e) {
          showBootError(e instanceof Error ? e.message : String(e));
        }
      });
      this.load.start();
    } catch (e) {
      showBootError(e instanceof Error ? e.message : String(e));
    }
  }
}
